import { formatNumber } from 'util/formatNumber';

export function getDownloadPlanBody(dataSimulator, projectId, amount) {
  const order = {
    0: 'Período',
    1: 'Total cuota',
    2: 'Abono a capital',
    3: 'Intereses',
    4: 'Saldo de capital',
    5: 'Período de gracia',
  };
  const allQuotas = {};
  for (let i = 0; i < dataSimulator?.length; i += 1) {
    allQuotas[i + 1] = {
      'Abono a capital': formatNumber(dataSimulator[i].fixedFee || dataSimulator[i].capital || 0),

      'Total cuota':
      formatNumber(dataSimulator[i].fixedFee
        + dataSimulator[i].interest
        - dataSimulator[i].reteFuente
      || dataSimulator[i].capital
        + dataSimulator[i].interescuota
        - dataSimulator[i].reteFuente
      || 0),
      'Período de gracia': dataSimulator[i].graciaTime === true ? 'Si' : 'No',
      'Saldo de capital': formatNumber(dataSimulator[i].paymentToCapital || dataSimulator[i].saldoinicial || 0),
      Período: dataSimulator[i].cuota || dataSimulator[i].numeroCuota,
      Intereses: formatNumber(dataSimulator[i].interest || dataSimulator[i].interescuota || 0),
    };
  }

  return {
    data: allQuotas,
    order,
    projectId,
    amount,
  };
}
